import React from 'react'
import Store from 'store'
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'
import Configurator from './components/Configurator'
import RegionPicker from './components/RegionPicker'
import Video from './components/Video'
import HandlePicker from './components/HandlePicker'

import './App.css'

// Init store
Store.set('visualize', {})

let routerBasename = '/'
// if (process.env.NODE_ENV === 'production') {
//   routerBasename = '/aluk/configurator/'
// }

const App = () => (
  <div className='App-content'>
    <Router basename={routerBasename}>
      <Switch>
        <Route exact path='/' component={RegionPicker} />
        <Route exact path='/:region' component={Video} />
        <Route exact path='/:region/novae' component={HandlePicker} />
        <Route exact path='/:region/:handle' component={Configurator} />
      </Switch>
    </Router>
  </div>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js